import { render, staticRenderFns } from "./publicTable.vue?vue&type=template&id=3cd28555"
import script from "./publicTable.vue?vue&type=script&lang=ts"
export * from "./publicTable.vue?vue&type=script&lang=ts"
import style0 from "./publicTable.vue?vue&type=style&index=0&id=3cd28555&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports